import { render } from "./MyBankView.vue?vue&type=template&id=37705e37&scoped=true"
import script from "./MyBankView.vue?vue&type=script&lang=js"
export * from "./MyBankView.vue?vue&type=script&lang=js"

import "./MyBankView.vue?vue&type=style&index=0&id=37705e37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37705e37"]])

export default __exports__